module.exports = __webpack_public_path__ + "img/balcony-256.d86589a0.jpg";